// ── SmartTraQ Team Page ──
import React, { useState, useMemo } from "react";
import { T, _themeIdx, isDark, Ic, sIG, sBG } from './theme.jsx';
import { RLS, HF, DEFAULT_ROLE_PERMS } from './constants';
import { RoB } from './ui.jsx';

function TeamPg({users,cur,edt,nw,sa,onRemove,onRoleChange,ROLE_PERMS,onInvite,companyName,orgId,log,tasks,onAddTask,orders}) {
  if(!cur) return null;
  const displayed=useMemo(()=>{
    const list=[...(users||[])];
    if(!list.some(u=>u.id===cur.id))list.unshift(cur);
    return list;
  },[users,cur]);
  const [confirmRemove,setConfirmRemove]=useState(null);
  const [invEmail,setInvEmail]=useState('');
  const [invRole,setInvRole]=useState('viewer');
  const [invSending,setInvSending]=useState(false);
  const doInvite=()=>{
    if(!invEmail.trim()||!invEmail.includes('@'))return;
    setInvSending(true);
    onInvite&&onInvite(invEmail.trim(),invRole);
    setInvEmail('');
    setTimeout(()=>setInvSending(false),1000);
  };
  const roleAccess=(role)=>{
    const rp=(ROLE_PERMS||DEFAULT_ROLE_PERMS)[role]||{};
    const pages=rp.pages||[];
    const perms=[];
    if(rp.eo)perms.push("Edit Orders");
    if(rp.es)perms.push("Edit Shipments");
    if(rp.ec)perms.push("Edit Customers");
    if(rp.ev)perms.push("Edit Vendors");
    if(rp.approve)perms.push("Approve");
    if(rp.canDelete)perms.push("Delete");
    if(rp.ordReadOnly)perms.push("Orders Read-Only");
    return {pages:pages.length,perms};
  };
  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div><h3 style={{fontSize:15,fontWeight:700,margin:0,fontFamily:HF}}>Team Members</h3><p style={{fontSize:11,color:T.tm,margin:"2px 0 0"}}>{displayed.length} member{displayed.length!==1?"s":""} in your organization</p></div>
      </div>
      {/* Inline invite form — same logic as Settings → Invite Team */}
      {sa&&onInvite&&<div style={{background:T.sf+"80",borderRadius:14,border:"1px solid "+(_themeIdx===0?"rgba(255,255,255,.06)":T.bd+"50"),padding:16,marginBottom:18}}>
        <div style={{fontSize:12,fontWeight:700,marginBottom:10,color:T.tx}}>Invite a Team Member</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <input value={invEmail} onChange={e=>setInvEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&doInvite()} placeholder="colleague@company.com" style={{flex:"1 1 200px",padding:"9px 12px",borderRadius:8,border:"1px solid "+T.bd,background:T.sl,color:T.tx,fontSize:12,fontFamily:"'Inter',system-ui,-apple-system,sans-serif",outline:"none"}}/>
          <select value={invRole} onChange={e=>setInvRole(e.target.value)} style={{padding:"9px 10px",borderRadius:8,border:"1px solid "+T.bd,background:T.sl,color:T.tx,fontSize:12,fontFamily:"'Inter',system-ui,-apple-system,sans-serif",cursor:"pointer"}}>
            {RLS.map(r=><option key={r.id} value={r.id}>{r.n}</option>)}
          </select>
          <button onClick={doInvite} disabled={invSending||!invEmail.trim()||!invEmail.includes("@")} style={{padding:"9px 18px",borderRadius:8,border:"none",background:invEmail.includes("@")?"linear-gradient(135deg,#2563EB,#0891B2)":"rgba(255,255,255,.06)",color:invEmail.includes("@")?"#FFF":"#475569",fontSize:12,fontWeight:700,cursor:invEmail.includes("@")?"pointer":"not-allowed",fontFamily:"'Inter',system-ui,-apple-system,sans-serif",flexShrink:0}}>
            {invSending?"Sending...":"Send Invite"}
          </button>
        </div>
        <div style={{fontSize:10,color:T.tm,marginTop:8}}>An email invite with a join link will be generated. You can review it before sending.</div>
      </div>}
      {displayed.length===0?(
        <div style={{padding:40,textAlign:"center",borderRadius:14,border:"1px dashed "+T.bd,background:T.sl}}>
          <Ic n="team" s={32}/><div style={{fontSize:13,fontWeight:600,marginTop:12,color:T.ts}}>No team members yet</div>
          <div style={{fontSize:11,color:T.tm,marginTop:4}}>Use the invite form above to add colleagues.</div>
        </div>
      ):(
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:12}}>
        {displayed.map(u=>{
          const isSelf=u.id===cur.id;
          const ra=roleAccess(u.role);
          return(
          <div key={u.id} className="lf" style={{background:T.sf+"80",borderRadius:14,border:"1px solid "+(isSelf?T.ac+"30":T.bd),padding:18,position:"relative"}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
              <div style={{width:44,height:44,borderRadius:14,background:T.gr,display:"flex",alignItems:"center",justifyContent:"center",color:"#FFF",fontSize:15,fontWeight:700}}>{String(u.av||"?")}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:14,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{String(u.name||"Unnamed")}{isSelf && <span style={{fontSize:10,color:T.ac,marginLeft:6}}>(You)</span>}</div>
                <div style={{fontSize:11,color:T.tm,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{String(u.email||"")}</div>
              </div>
              <span style={{fontSize:10,fontWeight:600,color:u.on!==false?T.gn:T.rd,flexShrink:0}}>{u.on!==false?"Active":"Disabled"}</span>
            </div>
            {/* Role selector */}
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
              {sa&&!isSelf&&!u.is_owner&&onRoleChange?(
                <select value={u.role||"viewer"} onChange={e=>onRoleChange(u.id,e.target.value)} style={{padding:"4px 8px",borderRadius:6,border:"1px solid "+T.bd,background:T.sl,color:T.tx,fontSize:11,fontWeight:600,fontFamily:"'Inter',system-ui,-apple-system,sans-serif",cursor:"pointer"}}>
                  {RLS.map(r=><option key={r.id} value={r.id}>{r.n}</option>)}
                </select>
              ):<div style={{display:"flex",alignItems:"center",gap:6}}><RoB r={u.role}/>{u.is_owner&&<span style={{fontSize:8,fontWeight:700,padding:"2px 7px",borderRadius:6,background:"linear-gradient(135deg,rgba(245,158,11,.1),rgba(234,179,8,.1))",color:"#D97706",border:"1px solid rgba(245,158,11,.2)"}}>OWNER</span>}</div>}
              <span style={{fontSize:9,color:T.tm}}>{ra.pages} pages</span>
              {ra.perms.length>0&&<span style={{fontSize:9,color:T.tm}}>{"\u00B7"} {ra.perms.slice(0,2).join(", ")}{ra.perms.length>2?"...":""}</span>}
            </div>
            {/* Actions */}
            {sa&&!isSelf&&!u.is_owner&&(
              <div style={{display:"flex",gap:6,borderTop:"1px solid "+T.bd+"40",paddingTop:10}}>
                {confirmRemove===u.id?(
                  <div style={{display:"flex",gap:4,alignItems:"center",flex:1}}>
                    <span style={{fontSize:10,color:T.rd,fontWeight:600}}>Remove from team?</span>
                    <button onClick={()=>{onRemove&&onRemove(u.id);setConfirmRemove(null)}} style={{fontSize:10,fontWeight:700,padding:"4px 10px",borderRadius:6,background:"rgba(239,68,68,.1)",border:"1px solid rgba(239,68,68,.3)",color:T.rd,cursor:"pointer",fontFamily:"'Inter',system-ui,-apple-system,sans-serif"}}>Yes, Remove</button>
                    <button onClick={()=>setConfirmRemove(null)} style={{fontSize:10,fontWeight:600,padding:"4px 10px",borderRadius:6,background:"transparent",border:"1px solid "+T.bd,color:T.tm,cursor:"pointer",fontFamily:"'Inter',system-ui,-apple-system,sans-serif"}}>Cancel</button>
                  </div>
                ):(
                  <button onClick={()=>setConfirmRemove(u.id)} style={{fontSize:10,fontWeight:600,padding:"4px 10px",borderRadius:6,background:"transparent",border:"1px solid "+T.rd+"25",color:T.rd,cursor:"pointer",fontFamily:"'Inter',system-ui,-apple-system,sans-serif",opacity:.7}}>Remove</button>
                )}
              </div>
            )}
          </div>
        )})}
      </div>
      )}

      {/* ── Team Activity Feed ── */}
      <div style={{marginTop:20}}>
        <h3 style={{fontSize:14,fontWeight:700,margin:"0 0 12px",fontFamily:HF}}>Team Activity</h3>
        {(log||[]).length===0?<div style={{padding:24,textAlign:"center",borderRadius:14,border:"1px dashed "+T.bd,background:T.sl,fontSize:11,color:T.tm}}>No activity yet — actions will appear here</div>:
        <div style={{display:"flex",flexDirection:"column",gap:4,maxHeight:320,overflowY:"auto",paddingRight:4}}>
          {(log||[]).slice(0,30).map((l,i)=>{
            const ic=l.cat==="order"?"pkg":l.cat==="ship"?"ship":l.cat==="team"?"team":l.cat==="rfq"?"env":l.cat==="import"?"dl":"chk";
            const cc=l.cat==="order"?"#3B82F6":l.cat==="ship"?"#06B6D4":l.cat==="team"?"#EC4899":l.cat==="rfq"?"#0E7490":"#6B7280";
            return(<div key={i} style={{display:"flex",gap:10,padding:"8px 12px",borderRadius:10,background:i%2===0?(isDark()?"rgba(255,255,255,.02)":T.sl+"60"):"transparent",alignItems:"flex-start"}}>
              <div style={{width:28,height:28,borderRadius:8,background:cc+"10",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}><Ic n={ic} s={12} style={{color:cc}}/></div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:600,color:T.tx,lineHeight:1.3}}>{l.msg}</div>
                <div style={{fontSize:10,color:T.tm,marginTop:2}}>{l.at?new Date(l.at).toLocaleDateString("en-US",{month:"short",day:"numeric",hour:"numeric",minute:"2-digit"}):""}</div>
              </div>
            </div>);
          })}
        </div>}
      </div>

      {/* ── Quick Task Assignment ── */}
      {sa&&onAddTask&&<QuickTeamTask users={users} cur={cur} tasks={tasks} orders={orders} onAddTask={onAddTask}/>}
    </div>
  );
}

const QuickTeamTask=React.memo(function QuickTeamTask({users,cur,tasks,orders,onAddTask}){
  const [tTitle,setTTitle]=useState("");
  const [tAssignee,setTAssignee]=useState("");
  const [tDue,setTDue]=useState("");
  const [tPri,setTPri]=useState("Medium");
  const [tRef,setTRef]=useState("");
  const teamList=(users||[]).filter(u=>u.on!==false&&u.name);
  const doAdd=()=>{
    if(!tTitle.trim())return;
    onAddTask({title:tTitle.trim(),assignee:tAssignee||cur?.name,due:tDue,priority:tPri,refId:tRef,type:tRef?"order":"general",note:"Assigned from Team page"});
    setTTitle("");setTDue("");setTRef("");
  };
  const activeTasks=(tasks||[]).filter(t=>!t.done);
  return(
    <div style={{marginTop:20}}>
      <h3 style={{fontSize:14,fontWeight:700,margin:"0 0 12px",fontFamily:HF}}>Assign Task to Team</h3>
      <div style={{padding:16,borderRadius:14,background:isDark()?"rgba(255,255,255,.02)":T.sl+"80",border:"1px solid "+(isDark()?"rgba(255,255,255,.04)":T.bd+"40")}}>
        <div style={{display:"flex",gap:8,marginBottom:8}}>
          <input value={tTitle} onChange={e=>setTTitle(e.target.value)} onKeyDown={e=>e.key==="Enter"&&doAdd()} placeholder="Task description..." style={{...sIG(),flex:1,padding:"8px 12px",fontSize:12}}/>
          <button onClick={doAdd} disabled={!tTitle.trim()} style={{...sBG(),padding:"8px 16px",fontSize:11,opacity:tTitle.trim()?1:.4}}>Assign</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:6}}>
          <select value={tAssignee} onChange={e=>setTAssignee(e.target.value)} style={{...sIG(),padding:"6px 8px",fontSize:11}}>
            <option value="">Assign to...</option>
            {teamList.map(u=><option key={u.id} value={u.name}>{u.name}</option>)}
          </select>
          <input type="date" value={tDue} onChange={e=>setTDue(e.target.value)} style={{...sIG(),padding:"6px 8px",fontSize:11}}/>
          <select value={tPri} onChange={e=>setTPri(e.target.value)} style={{...sIG(),padding:"6px 8px",fontSize:11}}>
            {["Urgent","High","Medium","Low"].map(p=><option key={p}>{p}</option>)}
          </select>
          <select value={tRef} onChange={e=>setTRef(e.target.value)} style={{...sIG(),padding:"6px 8px",fontSize:11}}>
            <option value="">Link to order...</option>
            {(orders||[]).slice(0,20).map(o=><option key={o.id} value={o.id}>{o.id} — {o.nm||o.cust||""}</option>)}
          </select>
        </div>
        {activeTasks.length>0&&<div style={{marginTop:12}}>
          <div style={{fontSize:10,fontWeight:700,color:T.tm,textTransform:"uppercase",letterSpacing:".05em",marginBottom:6}}>Active Tasks ({activeTasks.length})</div>
          <div style={{display:"flex",flexDirection:"column",gap:3,maxHeight:180,overflowY:"auto"}}>
            {activeTasks.slice(0,15).map(t=>{
              const pri=t.priority==="Urgent"?"#DC2626":t.priority==="High"?"#F59E0B":"#3B82F6";
              return(<div key={t.id} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 10px",borderRadius:8,background:isDark()?"rgba(255,255,255,.02)":"rgba(0,0,0,.02)",border:"1px solid "+T.bd+"30"}}>
                <div style={{width:4,height:16,borderRadius:2,background:pri,flexShrink:0}}/>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:11,fontWeight:600,color:T.tx,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.title}</div>
                  <div style={{fontSize:9,color:T.tm}}>{(t.assignees||[]).join(", ")||"Unassigned"}{t.due?" · Due "+t.due:""}{t.refId?" · "+t.refId:""}</div>
                </div>
              </div>);
            })}
          </div>
        </div>}
      </div>
    </div>
  );
});

export default TeamPg;
